import pro1 from "../assets/studentstudyportal.jpeg" 
import pro2 from "../assets/dailynews.png" 
import pro3 from "../assets/pomodoro.png" 

const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Student Study Portal",
        text:"The Student Study Portal is a Django-based applicatoin that streamlines academic tasks by integrating note-taking, homework management, and to-do lists into one platform. It provides easy access to resources like YouTube, Wikipedia, and dictionaries, with secure user authentication and data management.",
        view:"https://github.com/minic7/Student-Study-Portal"

    },
    {
        imgsrc: pro2,
        title: "Newzly: Real-Time News ",
        text:"Newzly is a dynamic React-based application designed to keep users informed with the latest news from a variety of sources ensuring seamless content aggregation, providing users with a comprehensive view of current events. The application features a user-friendly interface where users can view all at one place.",
        view:"https://github.com/minic7/NewsAPI"

    },
    {
        imgsrc: pro3,
        title: "25/5 Bliss",
        text:"The Pomodoro Technique in Python is a time management tool that uses 25-minute work intervals, followed by short breaks, to boost productivity. This script automates the timing, making it easy to manage work sessions and breaks efficiently. It includes notifications to signal when it's time to work or rest.",
        view:"https://github.com/minic7/Pomodoro"

    },
];

export default ProjectCardData
